module.exports = __webpack_public_path__ + "img/arrow.a6a82dd0.svg";